"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicMetrics = void 0;
exports.LogicMetrics = {
    DeckCards: 52,
    WildCards: 2,
    TargetScore: 21,
    StackCardPoints: 10,
    ColumnTargetPointsPerCard: 100,
    ColumnBustPoints: 500,
};
